import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPredictorApexIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19 3C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H19ZM9.8125 9.8125L5 12L9.8125 14.1875L12 19L14.1875 14.1875L19 12L14.1875 9.8125L12 5L9.8125 9.8125Z",
		fill: "currentColor"
	})
});
export default SvgPredictorApexIcon;
